import React from 'react';
import {RenderResult} from '@testing-library/react';
import {has} from 'lodash';
import stateMachine from './ClientStateMachine.service';
import utilService from './utilService';
import {_FILES} from '../configuration/index.config';
import {textInputValidation} from './TextInputValidation.service';
import imageCompression from 'browser-image-compression';
const {VIDEO} = _FILES;

export interface IImage {
    src:string,
    width:number,
    height:number,
    name?:string,
    isAllow?:boolean,
    isLoadDelete?:boolean,
    data?:any,
    finished:boolean,
    isVideoLoad:boolean,
    filename?:string,
    buttonMode:string
}
interface IAllData{
    imageObject?: any,
    img?: IImage,
    attributes?: string[],
    labels?: string[],
    filename?:string,
    fileType?:string,
    className?:string,
    'unique_request_id'?:string
}
class LoadService {
    public allDataFromLocal: IAllData[] = [];
    public jsonAnnotationsKeys: any =null
    public imageUploadArray:any= [];
    public numberOfFilesUploaded = 0;
    public indexSentUpload = 0;
    public imageUploadList:any = new Map();
    public allFiles:any = [];
    public videosFiles:any = [];
    public imagesNames:string[] = [];
    public classificationObj:any = [];
    public foldersNames:string[] =[];
    public base64Data:any = [];

    /**
     * setUploadImages - set all upload properties
     */
    setUploadImages = () => {
        this.imageUploadArray.splice(0, this.imageUploadArray.length);
        this.imagesNames.splice(0, this.imageUploadArray.length);
        this.indexSentUpload = 0;
        this.numberOfFilesUploaded = 0;
        this.imageUploadList = new Map();
        this.allFiles.splice(0, this.allFiles.length);
        this.videosFiles.splice(0, this.videosFiles.length);
        this.base64Data.splice(0, this.base64Data.length);
    }

    /**
     * changeImageInLoadArray - change image in allDataFromLocal
     * @param src - base64
     * @param index - index of the object
     */
    changeImageInLoadArray = (src, index) => {
        const img = this!.allDataFromLocal[index]!.img;
        const image:HTMLImageElement = new Image();

        image.src = src;
        img!.src = src;
        image.onload = () => {
            img!.width = image.width;
            img!.height = image.height;
        };
    }

    /**
     * setClassificationObj - set Classification Object
     * @param obj - the object from server
     */
    setClassificationObj = async (obj) => {
        if (obj.project_data) {
            this.classificationObj = obj;
            await stateMachine.setStoreOrServiceData([{serviceName: 'loadService', newData: {classificationObj: this.classificationObj}}]);
        }
    }

    /**
     * setLoadService - delete allDataFromLocal
     */
    setLoadService = () => {
        this.allDataFromLocal.splice(0, this.allDataFromLocal.length);
        this.jsonAnnotationsKeys = null;
    }

    /**
     * deleteDataFromAllDataFromLocal - delete allDataFromLocal value by index
     */
    deleteDataFromAllDataFromLocal = (index, isNull = false) => {
        (this.allDataFromLocal && this.allDataFromLocal[index]) && isNull ? this.allDataFromLocal.splice(index, index, {}) : this.allDataFromLocal.splice(index, index + 1);
    }

    /**
     * requestMore - request ten more for view
     * @param index - index start
     * @param amount - amount of images
     */
    requestMore = (index, amount) => this.getAllDataFromLocal().slice(index + 1, index + amount)

    /**
     * getAllDataFromLocal - get copy of allDataFromLocal array
     */
    getAllDataFromLocal() {

        return JSON.parse(JSON.stringify(this.allDataFromLocal));
    }

    /**
     * saveJsonAnnotationsKeys - save Json annotations keys to check what need to come back to backend
     * @param obj - the Annotation object
     */
    saveJsonAnnotationsKeys(obj) {
        obj ? !this.jsonAnnotationsKeys && (this.jsonAnnotationsKeys = obj) : !this.jsonAnnotationsKeys && (this.jsonAnnotationsKeys = {label: '', attributes: [], type: '', coordinates: []});
    }

    /**
     * findFromAllDataByName - find index of allDataFromLocal
     * @param data - data.img_name - to find the image name
     */
    findFromAllDataByName = (data) => this.allDataFromLocal.findIndex((imageData) => data.img_name.split('.')[0] === imageData.filename);

    /**
     * addDataToArray - add to allDataFromLocal array
     * @param data - the data that need to be saved
     * @param index - if index it will replace the object in the index
     */
    addDataToArray(data, index = -1) {
        return new Promise<{img:IImage, imageObject:any}>((resolve) => {
            const image:HTMLImageElement = new Image();
            const img = {src: data.img, width: 0, height: 0, finished: false, isVideoLoad: false, buttonMode: 'default'};

            const imageObject = data.json || {annotations: []};
            const uniqueRequestId = data.unique_request_id ? data.unique_request_id : '';
            const filename = data.img_name ? data.img_name.split('.')[0] : '';
            const fileType = data.img_name ? data.img_name.split('.')[1] : '';

            imageObject.className = data.json && data.json.className || '';

            this.saveJsonAnnotationsKeys(imageObject.annotations[0]);
            const localData:any = {img, imageObject, attributes: data.attributes, labels: data.labels, 'unique_request_id': uniqueRequestId, filename, fileType};

            if (index > -1) {
                this.allDataFromLocal[index] = JSON.parse(JSON.stringify(localData));
            } else {
                this.allDataFromLocal = (data.json && data.json.finished) || data.vid_index ? [...this.allDataFromLocal, localData] : [localData, ...this.allDataFromLocal];
            }


            if (typeof data.img === 'string') {
                if (this.allDataFromLocal.length > 1) {
                    resolve({img, imageObject});
                } else {
                    image.src = data.img;
                    image.onload = () => {
                        img.width = image.width;
                        img.height = image.height;
                        resolve({img, imageObject});
                    };
                    image.onerror = () => resolve({img, imageObject});
                }
            }
        });
    }

    /**
     * setCoordinatesToCorrectSize - calculate correct coordinates on image
     * @param obj - the shape object
     * @param ratio - the ratio from aspect ratio
     * @param isConvertToJson - if true calculation for backend else for front
     */
    setCoordinatesToCorrectSize = (obj, ratio, isConvertToJson) => {

        if (obj.coordinates.length > 0) {
            const coordinatesArray = obj.coordinates[0].length > 0 ? obj.coordinates[0] : obj.coordinates;

            coordinatesArray.forEach((cordItem) => {
                for (const cord in cordItem) {
                    if (has(cordItem, cord) && (cord === 'x' || cord === 'y')) {
                        cordItem[cord] = isConvertToJson ? parseInt(`${cordItem[cord] * ratio}`, 10) : parseInt(`${cordItem[cord] / ratio}`, 10);
                    } else if (has(cordItem, cord) && !(cord === 'x' || cord === 'y')) {
                        delete cordItem[cord];
                    }
                }
                !('z' in cordItem) && (cordItem.z = 0);
            });
        } else {
            for (const cord in obj.coordinates) {
                if (has(obj.coordinates, cord) && (cord === 'x' || cord === 'y')) {
                    obj.coordinates[cord] = isConvertToJson ? parseInt(`${obj.coordinates[cord] * ratio}`, 10) : parseInt(`${+obj.coordinates[cord] / ratio}`, 10);
                }
            }
            !('z' in obj.coordinates) && (obj.coordinates.z = 0);
        }

        return obj;
    }

    /**
     * updateJsonAnnotations - update the annotations for backend
     * @param updateArray - the new array
     * @param ratio - the ratio from aspect ratio
     */
    updateJsonAnnotations = (updateArray, ratio) => updateArray.map((item) => {
        this.setCoordinatesToCorrectSize(item, ratio, true);

        for (const key in item) {
            if (has(item, key)) {
                !(key in this.jsonAnnotationsKeys) && (delete item[key]);
                if (key === 'attributes') {
                    item[key] = [item[key]];
                }
            }
        }

        return item;
    })

    /**
     * setAllDataFromLocalJson - update the json Controllers
     * @param index - which image to update
     * @param updateArray - the new array
     * @param ratio - the ratio from aspect ratio
     * @param className - if className is in the json
     */
    setAllDataFromLocalJson = (index, updateArray, ratio, className = '') => {
        const copyUpdateArray = JSON.parse(JSON.stringify(updateArray));

        className && (this!.allDataFromLocal![index]!.imageObject.className = className);
        this!.allDataFromLocal![index]!.imageObject.annotations && this!.allDataFromLocal![index]!.imageObject.annotations.splice(0, this!.allDataFromLocal![index]!.imageObject.annotations.length);
        this.updateJsonAnnotations(copyUpdateArray, ratio).forEach((item) => {
            this!.allDataFromLocal![index]!.imageObject.annotations.push(item);
        });
    }

    /**
     * loadLocalFiles - load from local data (not s3)
     * @param img - the image data
     * @param json - the json data
     */
    loadLocalFiles({img, json}:any) : Promise<IAllData> {
        return new Promise<IAllData>((resolve) => {
            let imageObject:any = null;
            const image:HTMLImageElement = new Image();

            if (json) {
                try {
                    const result = JSON.parse(json.result);

                    'annotations' in result ? imageObject = result : imageObject = {annotations: result};
                } catch (e) {
                    console.error(`error  in json : ${e}`);
                }

            }
            if (img) {
                if (typeof img.result === 'string') {
                    image.src = img.result;
                }
            }

            image.onload = () => {
                const img = {src: image.src, width: image.width, height: image.height, finished: false, isVideoLoad: false, buttonMode: 'default'};


                resolve({img, imageObject});
            };
        });
    }

    /**
     * getDataFromFolder - load data from folder
     * @param folderFiles - all files in folder
     * @param FromUploadNew - this is the data from upload data
     */
    getDataFromFolder(folderFiles: any, FromUploadNew = {}): any {
        // eslint-disable-next-line no-async-promise-executor
        const _loadData = (allData) => new Promise<IAllData[] | null[]>(async (resolve) => {
            const renderData = {};
            let newKey = 'json';

            for (const key in allData) {
                if (has(allData, key)) {
                    newKey = key.includes('image') ? 'img' : 'json';
                    const maiName = allData[key].name.split('.')[0];

                    this.imagesNames.push(allData[key].name);
                    renderData[`${maiName}`] ? renderData[`${maiName}`][newKey] = allData[key].reader : renderData[`${maiName}`] = {[newKey]: allData[key].reader};
                }

            }

            const promises:Promise<IAllData | null>[] = [];


            for (const imageObject of [...Object.values(renderData)]) {
                promises.push(this.loadLocalFiles(imageObject));
            }
            const valuesArray:Array<any> = await Promise.all(promises);


            if (!FromUploadNew) {
                this.allDataFromLocal = [...this.allDataFromLocal, ...valuesArray];
                resolve(this.allDataFromLocal);
            } else {
                resolve(valuesArray);
            }
        });

        if (FromUploadNew) {
            return _loadData(FromUploadNew);
        }

        return this._readToData(folderFiles)
            .then((allData) => _loadData(allData)).catch((err) => {
                console.error(err);

                return err;
            });


    }

    /**
     * _readToData - insert the render file to array (from all files type)
     * @param folderFiles - all files
     */
    readAllFiles(folderFiles: React.ChangeEvent<HTMLInputElement>) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise<RenderResult>(async (resolve) => {
            const allData:any = {};

            if (folderFiles.target.files instanceof FileList) {
                const saveData = async (file) => {
                    const reader:FileReader = await new FileReader();

                    await reader.readAsDataURL(file);
                    allData[`${file.type}_${file.name}`] = { reader, name: file.name};
                    this.numberOfFilesUploaded++;

                };

                for (const file of folderFiles.target.files) {
                    await saveData(file);
                }
            }
            resolve(allData);
        });
    }

    /**
     * _readToData - insert the render file to array
     * @param folderFiles - all files
     */
    _readToData(folderFiles: React.ChangeEvent<HTMLInputElement>) {
        // eslint-disable-next-line no-async-promise-executor
        return new Promise<RenderResult>(async (resolve) => {
            const allData:any = {};

            if (folderFiles.target.files instanceof FileList) {
                const saveData = async (file) => {
                    const reader:FileReader = await new FileReader();

                    if (file.type.includes('image')) {
                        await reader.readAsDataURL(file);
                        allData[`${file.type}_${file.name}`] = { reader, name: file.name};
                        this.numberOfFilesUploaded++;
                    } else if (file.type.includes('json')) {
                        await reader.readAsText(file);
                        allData[`${file.type}_${file.name}`] = { reader, name: file.name};
                        this.numberOfFilesUploaded++;
                    }

                };

                for (const file of folderFiles.target.files) {
                    await saveData(file);
                }
            }
            resolve(allData);
        });
    }
    loopOnFiles = (files, isLocalScope = false, imageType:null | RegExp = null) => {
        const _allFiles = isLocalScope ? [] : this.allFiles;

        for (const i in files) {
            if (has(files, i)) {
                const isUploadFile = imageType ? files[i].type.match(imageType) : true;

                isUploadFile && _allFiles.push(files[i]);
            }
        }

        return _allFiles;
    };

    /**
     * uploadAllFiles - load all file (doesn't matter type file)
     * @param e - all files (event)
     */
    uploadAllFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files instanceof FileList) {
            return this.loopOnFiles(e.target.files);
        }

        return this.allFiles;
    }

    /**
     * openFile - open image or video file
     * @param file - file object
     */
    openFile = (file) => new Promise<any>((resolve, reject) => {
        const reader = new FileReader();

        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = (error) => reject(error);
    });

    /**
     * toBase64 - get base64 from image file
     * @param file - image file
     * @param type - file type
     */
    toBase64 = (file, type = 'image') => new Promise((resolve, reject) => {
        const fileNameArray = file.name.split('.');

        if ((type === 'image' && file.type.includes('image')) || type === 'hdf5' && fileNameArray[fileNameArray.length - 1] === 'hdf5') {
            const reader = new FileReader();

            reader.readAsDataURL(file);
            reader.onload = () => {
                type === 'hdf5' && this.base64Data.push({
                    fileChunks: utilService.splitStringIntoChunks(reader.result, 2000000),
                    name: file.name,
                    index: 0
                });
                resolve(reader.result);
            };
            reader.onerror = (error) => reject(error);
        } else {
            reject('not a valid data');
        }

    });

    /**
     * handleImageUpload - this is a uload with comress
     * @param e
     */
    async handleImageUpload(e) {
        const imageFile = e.target.files[0];

        const options = {
            maxSizeMB: 0.5,
            maxWidthOrHeight: 1920,
            useWebWorker: true
        };

        try {
            const compressedFile = await imageCompression(imageFile, options);

            return this.toBase64(compressedFile);
        } catch (error) {
            console.log(error);

            return '';
        }

    }

    /**
     * uploadImages - upload Images (and jsons)
     * @param folderFiles - the folder of the images
     */
    uploadImages = (folderFiles: React.ChangeEvent<HTMLInputElement>) => new Promise<any>((resolve) => {
        this._readToData(folderFiles).then((imgDataUpload) => {
            for (const key in imgDataUpload) {
                if (key.includes('image')) {
                    const jsonKey = `application/json_${imgDataUpload[key].name.split('.')[0]}.json`;

                    imgDataUpload[jsonKey]
                        ? this.imageUploadArray.push({[key]: imgDataUpload[key], [jsonKey]: imgDataUpload[jsonKey]})
                        : this.imageUploadArray.push({[key]: imgDataUpload[key]});

                    this.imageUploadList[imgDataUpload[key].name] = this.imageUploadArray.length - 1;


                }
            }
            resolve(this.imageUploadArray);
        });
    })

    deleteVideoByFOlderName = (folderName) => {
        const numberOfFilesDeleted = this.videosFiles.filter((video) => video.folderName === folderName).length;

        this.foldersNames = this.foldersNames.filter((folder) => folder !== folderName);
        this.videosFiles = this.videosFiles.filter((video) => video.folderName !== folderName);

        return numberOfFilesDeleted;
    }

    /**
     * uploadVideosFromLocal - upload Videos From Local
     * @param files - the folder of the images
     */
    uploadVideosFromLocal = (files) => {
        const foldersNames:string[] = [...this.foldersNames];
        const videosBig:string[] = [];

        for (const key in files) {
            if (has(files, key)) {
                if (files[key].type.includes('video') && !this.videosFiles.find((video) => video.name === files[key].name)) {
                    if (this.validateSize(files[key], VIDEO.MAX_SIZE)) {
                        const folderName:string = files[key].webkitRelativePath.split('/');
                        const mainFolder = textInputValidation.filterValue(folderName[folderName.length - 2]);

                        foldersNames.push(mainFolder);
                        this.videosFiles.push({name: files[key].name, blob: files[key], folderName: mainFolder});
                    } else {
                        videosBig.push(files[key].name);
                    }
                }
            }
        }
        this.foldersNames = [...new Set(foldersNames)];

        return [this.videosFiles, videosBig];
    }

    /**
     * handleDownload - when user download the file
     * @param url - url for download
     * @param filename - the file name
     */
    handleDownload = (url, filename) => {
        const link = document.createElement('a');

        link.setAttribute('download', filename);
        link.href = url;
        document.body.appendChild(link);
        link.click();
        link.remove();
    }

    /**
     * aspectRatio - calculate by aspectRatio formula
     */
    aspectRatio=(containerWidth, containerHeight, img, isWidthBigger = true) => {
        const ifWidthBigger = isWidthBigger ? img.width > img.height : !(img.width > img.height);
        const widthHeight = ifWidthBigger ? 'width' : 'height';
        const ratio = widthHeight === 'width' ? img.width / containerWidth : img.height / containerHeight;
        const newWidth = parseInt(`${img.width / ratio}`, 10);
        const newHeight = parseInt(`${img.height / ratio}`, 10);

        if ((newWidth > containerWidth || newHeight > containerHeight) && isWidthBigger) {

            return this.aspectRatio(containerWidth, containerHeight, img, false);
        }

        return {width: `${newWidth}`, height: `${newHeight}`, ratio};
    }

     validateSize= (file, maxSize) => {
         const fileSize = parseInt(`${file.size / 1024 / 1024}`, 10);

         return fileSize <= maxSize;


     }
}

export default new LoadService();

